import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter } from '@fortawesome/free-brands-svg-icons';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faTumblr } from '@fortawesome/free-brands-svg-icons';

function Footer() {
	return (
		<footer>
			<div className="container">
				<ul className="social-links">
					<li><a href="http://instagram.com/pixelsandprint" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faInstagram} /></a></li>
					<li><a href="https://twitter.com/pixelsandprint" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faTwitter} /></a></li>
					<li><a href="https://pixelsandprintSU.tumblr.com" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faTumblr} /></a></li>
    </ul>
				<p>Copyright 2020-21, Newhouse School at Syracuse University.</p>
			</div>
		</footer>)
}
export default Footer;
